import React, { useState } from "react";
import styles from "../Users/UsersTable.module.css";
import deleteIcon from "../../../assets/Imagess/deleteicon.svg";
import editIcon from "../../../assets/Imagess/Edit (1).svg";
import Loader from "../Loader/Loader";
import Toggle from "../../Atoms/Inputs/Toggle";
import { useChangeEmailStatus } from "../../../Hooks/Notification";

const EmailTable = ({
  data,
  setShowDeleteModal,
  setSelectedEmail,
  handleEdit,
  isEmailLoading,
  refetchEmails,
}) => {
  const [isActiveStatus, setIsActiveStatus] = useState(false);

  const changeEmailStatus = useChangeEmailStatus();

  if (isEmailLoading) {
    return <Loader />;
  }

  const handleToggleChange = async (index) => {
    const updatedData = [...data];
    updatedData[index].isActive = !updatedData[index].isActive;
    setIsActiveStatus(!isActiveStatus);
    try {
      await changeEmailStatus.mutate(
        {
          NotificationId: updatedData[index].notificationId,
          isActive: updatedData[index].isActive,
        },
        {
          onSuccess: () => {
            refetchEmails();
          },
        }
      );
    } catch (error) {
      // Handle error if needed
      console.error("Error occurred while changing email status:", error);
    }
  };

  return (
    <table className={styles["userstable-container"]}>
      <thead>
        <tr>
          <th>Name</th>
          <th>Email Type</th>
          <th>Attachment</th>
          <th>Created By</th>
          <th>Status</th>

          <th></th>
        </tr>
      </thead>
      <tbody>
        {data?.map((item, index) => {
          return (
            <tr key={item.notificationId}>
              <td>{item.notificationName}</td>
              <td>{item.notificationType_Display}</td>
              <td>{item.hasAttachment}</td>
              <td>{item.userCreated}</td>
              <td>
                <Toggle
                  isActive={item.isActive}
                  onChange={() => handleToggleChange(index)}
                />
              </td>
              <td className={styles["icon-cont-table"]}>
                <img
                  src={editIcon}
                  alt="icon"
                  onClick={() => handleEdit(item)}
                />
                <img
                  src={deleteIcon}
                  alt="icon"
                  onClick={() => (
                    setShowDeleteModal(true), setSelectedEmail(item)
                  )}
                />
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default EmailTable;
